import {useQuery} from 'react-query'
import {
  api,
  queryClient,
  useMutationQuery,
  // replaceQueryClientDataItem,
} from 'base'
import {showSuccessNotification} from 'common/helpers'
// import {
//   REQUEST_STATUS_NAME,
//   REQUEST_MILESTONE_NAME,
//   RequestStatus,
//   RequestMilestone,
// } from '.'

export const useGetVariationRequest = (uuid: string, enabled?: boolean) => {
  return useQuery(
    ['variation-request', uuid],
    async () => {
      const {data} = await api.get(`/variationRequest/${uuid}`, {
        params: {
          include: 'statuses',
        },
      })
      return data.data
    },
    {enabled}
  )
}
export const useGetVariationTransactions = (uuid: string, enabled?: boolean) => {
  return useQuery(
    ['variation-transactions', uuid],
    async () => {
      const {data} = await api.get(`/variationRequest/${uuid}/schedule/getProjectTransactions`, {
        params: {
          include: 'statuses',
        },
      })
      return data.data
    },
    {enabled}
  )
}
export const useGetVariationTransactionsConfirmed = (uuid: string, enabled?: boolean) => {
  return useQuery(
    ['variation-transactions-confirmed', uuid],
    async () => {
      const {data} = await api.get(`/variationRequest/${uuid}/schedule/getProjectTransactionsConfirmed`, {
        params: {
          include: 'statuses',
        },
      })
      return data.data
    },
    {enabled}
  )
}

export const useGetVariationInitialForecast = (
  requestUuid: string,
) => {
  return useQuery(
    ['get-variation-init-forecast', requestUuid],
    async () => {
      const {data} = await api.get(`/variationRequest/${requestUuid}/schedule/getSystemDrawdown`)
      return data.data
    },
  )
}

export const useCreateVariationForecast = (
  projectUuid: string,
  onClose: () => void,
  // setForecastCreatedProjects: (projectUuid: string) => void
) => {
  return useMutationQuery<any, any, any>(
    ['create-Variation-Forecast', projectUuid],
    async (payload) => {
      const {data} = await api.post('/forecast/create', payload)
      return data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('variation-request')
        // setForecastCreatedProjects(projectUuid)
        // queryClient.invalidateQueries('forecast')
        showSuccessNotification('Variation forecast has been created.')
        onClose()
      },
    }
  )
}

export const useCreateVariationRequest = (
  onSuccessActions: (request: any) => void
) => {
  return useMutationQuery<any, any, any>(
    'createVariationRequest',
    async (values) => {
      const {data} = await api.post('/variationRequest/new', values)
      return data.data
    },
    {
      onSuccess(data) {
        queryClient.invalidateQueries('requests')
        queryClient.invalidateQueries('project')
        onSuccessActions(data)
        showSuccessNotification("Variation request has been created.")
      },
    }
  )
}
export const useUpdateVariationData = (
  requestUuid: string,
  onClose: () => void,
  // setForecastCreatedProjects: (requestUuid: string) => void
) => {
  return useMutationQuery<any, any, any>(
    ['update-variation-Forecast', requestUuid],
    async (payload) => {
      const {data} = await api.post(`/variationRequest/${requestUuid}`, payload)
      return data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('variation-request')
        // setForecastCreatedProjects(requestUuid)
        // queryClient.invalidateQueries('forecast')
        showSuccessNotification('Variation forecast has been updated.')
        onClose?.()
      },
    }
  )
}

export const useGetVariationSchedule = (uuid: string, type: 'establishFee' | 'lineFee' | 'finalSchedule') => {
  return useQuery(
    ['variation-schedule-info', uuid, type],
    async () => {
      const {data} = await api.get(`/variationRequest/${uuid}/schedule/${type}`)
      return data
    },
  )
}

export const useSetVariationEstablishmentFee = (
  uuid: string,
  onClose: () => void,
) => {
  return useMutationQuery<any, any, any>(
    ['set-variation-establishment-fee', uuid],
    async (payload) => {
      const url = `/variationRequest/${uuid}/schedule/establishFee`
      const {data} = await api.post(url, payload)
      return data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('variation-request')
        queryClient.invalidateQueries('variation-schedule-info')
        // setForecastCreatedProjects(projectUuid)
        // queryClient.invalidateQueries('forecast')
        showSuccessNotification('Variation establishment fee has been set.')
        onClose()
      },
    }
  )
}

export const useCalcVariationLineFee = (
  uuid: string,
  onResult: (data:any) => void,
) => {
  return useMutationQuery<any, any, any>(
    ['calc-variation-line-fee', uuid],
    async (payload) => {
      const url = `/variationRequest/${uuid}/utils/calculateLineFee?balance=${payload.balance}&lineFeeRate=${payload.lineFeeRate}`
      // alert(`${JSON.stringify({url, payload})}`)
      if (
        (payload.balance === undefined) ||
        (payload.lineFeeRate === undefined)
       ) {
        return null
      }
      const {data} = await api.get(url)
      return data
    },
    {
      onSuccess(data) {
        if (!data) return
        queryClient.invalidateQueries('variation-request')
        queryClient.invalidateQueries('variation-schedule-info')
        // setForecastCreatedProjects(projectUuid)
        // queryClient.invalidateQueries('forecast')
        // showSuccessNotification('Variation line fee has been re-calculated.')
        onResult(data)
      },
    }
  )
}

export const useSaveVariationLineFee = (
  uuid: string,
  onClose: () => void,
) => {
  return useMutationQuery<any, any, any>(
    ['save-variation-line-fee', uuid],
    async (payload) => {
      const url = `/variationRequest/${uuid}/schedule/saveLineFee`
      // alert(`${JSON.stringify({url, payload})}`)
      // return 
      const {data} = await api.post(url, payload)
      return data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('variation-request')
        queryClient.invalidateQueries('variation-schedule-info')
        // setForecastCreatedProjects(projectUuid)
        // queryClient.invalidateQueries('forecast')
        showSuccessNotification('Variation line fee has been saved.')
        onClose()
      },
    }
  )
}

export const useSaveVariationFacilityLimit2 = (
  uuid: string,
  onClose: () => void,
) => {
  return useMutationQuery<any, any, any>(
    ['save-variation-facility-limit-2', uuid],
    async (payload) => {
      const url = `/variationRequest/${uuid}/schedule/saveFC2`
      // alert(`${JSON.stringify({url, payload})}`)
      // return 
      const {data} = await api.post(url, payload)
      return data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('variation-request')
        queryClient.invalidateQueries('variation-schedule-info')
        // setForecastCreatedProjects(projectUuid)
        // queryClient.invalidateQueries('forecast')
        showSuccessNotification('Variation facility limit 2 has been saved.')
        onClose()
      },
    }
  )
}
